import { render, staticRenderFns } from "./UplimitMultiDayLadder.vue?vue&type=template&id=280fe4d8&scoped=true"
import script from "./UplimitMultiDayLadder.vue?vue&type=script&lang=js"
export * from "./UplimitMultiDayLadder.vue?vue&type=script&lang=js"
import style0 from "./UplimitMultiDayLadder.vue?vue&type=style&index=0&id=280fe4d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280fe4d8",
  null
  
)

export default component.exports